import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CalendlyUrl } from '../../../../core/enums/calendly-enums';

declare const Calendly: any;

@Component({
  selector: 'app-calendly-esgreporting-dialog',
  standalone: true,
  imports: [],
  templateUrl: './calendly-esgreporting-dialog.component.html',
  styleUrl: './calendly-esgreporting-dialog.component.css'
})
export class CalendlyESGReportingDialogComponent implements AfterViewInit {
  modalDialogId: string = 'services_modal_esg_reporting'
  calendlyElementId: string = 'calendly-embed-esg';

  constructor() { }

  ngAfterViewInit(): void {
    Calendly.initInlineWidget({
      url: CalendlyUrl.ESG_REPORTING,
      parentElement: document.getElementById(this.calendlyElementId),
      text: 'Schedule time with me',
      color: '#80a7a5',
      textColor: '#ffffff',
      branding: true
    });
  }

  openModal() {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.showModal();
  }

  closeModal(): void {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.close();
  }
}
